import React, { useState } from "react"
import Img from "gatsby-image"
import "./gallery-product.scss"

const GalleryProduct = ({ images = [], onClickVideo }) => {
  const [activeImage, setActiveImage] = useState(0)

  return (
    <div className="f-product-gallery">
      <div>
        <Img
          loading="eager"
          fluid={images[activeImage].fluid}
          className="f-product-gallery__main"
        />
      </div>

      <ul className="f-product-gallery__list">
        {images.map(({ fluid, isVideo }, index) => (
          <li
            key={index}
            onClick={() => {
              if (!isVideo) {
                setActiveImage(index)
              } else {
                onClickVideo()
              }
            }}
          >
            <div className="f-product-gallery__list-img">
              <Img fluid={fluid} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default GalleryProduct
